module.exports = __webpack_public_path__ + "img/13body 1.cbc08ee4.png";